import type { PoiCategory } from '@/types/api';
import type { IconName } from '@/components/ui/Icon/Icon';

/*
 * Per-category metadata for the map. The seven entries here mirror the PHP
 * PoiCategory enum (server/app/Enums/PoiCategory.php) and ADR-0011's lookup table:
 *
 *   id            ⇄ enum value (English, code identifier)
 *   labelKey      ⇄ key into nb.map.categories (Norwegian/sørlandsk UI label)
 *   icon          ⇄ Tabler icon name in the typed Icon set
 *   tokenVar      ⇄ CSS custom property carrying the category colour
 *
 * Used by the filter chips, the marker renderer, the radio-group in the add/edit
 * modal, and the popup eyebrow. Order is the display order ADR-0011 lists.
 */
export type PoiCategoryDef = {
  id: PoiCategory;
  labelKey: PoiCategory;
  icon: IconName;
  tokenVar: string;
};

export const POI_CATEGORIES: readonly PoiCategoryDef[] = [
  { id: 'swimming', labelKey: 'swimming', icon: 'swimming', tokenVar: '--color-poi-swimming' },
  { id: 'fishing', labelKey: 'fishing', icon: 'fish', tokenVar: '--color-poi-fishing' },
  { id: 'mooring', labelKey: 'mooring', icon: 'anchor', tokenVar: '--color-poi-mooring' },
  { id: 'sight', labelKey: 'sight', icon: 'binoculars', tokenVar: '--color-poi-sight' },
  { id: 'food', labelKey: 'food', icon: 'tools-kitchen-2', tokenVar: '--color-poi-food' },
  { id: 'acquaintance', labelKey: 'acquaintance', icon: 'home', tokenVar: '--color-poi-acquaintance' },
  { id: 'other', labelKey: 'other', icon: 'map-pin', tokenVar: '--color-poi-other' },
] as const;

export const POI_CATEGORY_BY_ID: Record<PoiCategory, PoiCategoryDef> = POI_CATEGORIES.reduce(
  (acc, def) => {
    acc[def.id] = def;
    return acc;
  },
  {} as Record<PoiCategory, PoiCategoryDef>,
);
